import React, { useState } from "react";
import { usePopover } from "../../App";
import { SettingsIcon } from "../../images/SettingsIcon";
import { Setting } from "../settings/Setting";
import { Modal } from "./Modal";

export type SettingsPanelId =
    | "psalms"
    | "morning lessons"
    | "evening lessons"
    | "compline psalms"
    | "invitatory"
    | "te deum"
    | "gospel canticles"
    | "salutation"
    | "suffrages"
    | "let us bless"
    | "office hymn"
    | "compline lesson"
    | "confession"
    | "lords prayer"
    | "collect";

export const SettingsButton: React.FC<{ settingsPanelId: SettingsPanelId }> = (
    props
) => {
    const { settingsPanelId } = props;

    const [modalContent, setModalContent] = useState(<></>);

    const { popoverId, setPopoverId } = usePopover();

    const isOpen = popoverId === settingsPanelId;

    const [isHovered, setIsHovered] = useState(false);

    const settingsContents = (() => {
        switch (settingsPanelId) {
            case "psalms":
                return (
                    <>
                        <Setting setting="psalmCycle" />
                        <Setting setting="psalmsBold" />
                    </>
                );

            case "morning lessons":
                return (
                    <>
                        <Setting setting="lectionary" />
                        <Setting setting="bibleTranslation" />
                    </>
                );

            case "evening lessons":
                return (
                    <>
                        <Setting setting="lectionary" />
                        <Setting setting="secondReadingToCompline" />
                        <Setting setting="bibleTranslation" />
                    </>
                );

            case "compline lesson":
                return (
                    <>
                        <Setting setting="secondReadingToCompline" />
                    </>
                );

            case "compline psalms":
                return (
                    <>
                        <Setting setting="psalmsAtCompline" />
                        <Setting setting="psalmsBold" />
                    </>
                );

            case "invitatory":
                return (
                    <>
                        <Setting setting="invitatoryAntiphons" />
                        <Setting setting="antiphonTones" />
                        <Setting setting="paschaNostrum" />
                    </>
                );

            case "te deum":
                return (
                    <>
                        <Setting setting="teDeum" />
                        <Setting setting="psalmsBold" />
                    </>
                );

            case "gospel canticles":
                return (
                    <>
                        <Setting setting="psalmsBold" />
                    </>
                );

            case "salutation":
                return (
                    <>
                        <Setting setting="salutation" />
                    </>
                );

            case "suffrages":
                return (
                    <>
                        <Setting setting="monarch" />
                    </>
                );

            case "let us bless":
                return (
                    <>
                        <Setting setting="letUsBlessMattinsAndEvensong" />
                    </>
                );

            case "office hymn":
                return (
                    <>
                        <Setting setting="hymnPosition" />
                    </>
                );

            case "confession":
                return (
                    <>
                        <Setting setting="absolution" />
                        <Setting setting="lordsPrayerAfterConfession" />
                    </>
                );

            case "lords prayer":
                return (
                    <>
                        <Setting setting="lordsPrayer" />
                    </>
                );

            case "collect":
                return (
                    <>
                        <Setting setting="adventAndLentCollects" />
                    </>
                );
        }
    })();

    return (
        <>
            <div
                style={{
                    width: 24,
                    height: 24,
                    pointerEvents: isOpen ? "none" : "all",
                    opacity: isOpen ? 0.5 : 1,
                    cursor: "pointer",
                    borderRadius: 4,
                    backgroundColor: isHovered ? "#e9e9e9" : "transparent",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
                onClick={() => {
                    setPopoverId(settingsPanelId);
                }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                <SettingsIcon />
            </div>
            <Modal
                id={settingsPanelId}
                title="Settings"
                onSetModal={setModalContent}
            >
                <div
                    style={{
                        paddingLeft: 8,
                        paddingRight: 8,
                        paddingBottom: 24,
                    }}
                >
                    {settingsContents}
                </div>
            </Modal>
            {modalContent}
        </>
    );
};
